export default __webpack_public_path__ + "static/media/votedapp.a7d0ebe4.png";